// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "9dadc25a" + "." + "6319f55548d5b013" + ".js";
};